let cachedClipboardText = "";

const initializeClipboardCache = () => {
	if (navigator?.clipboard?.readText) {
		navigator.clipboard.readText().then((text) => {
			if (typeof text === "string") {
				cachedClipboardText = text;
			}
		}).catch(() => {
			// ignore - clipboard permissions not granted
		});
	}
};

initializeClipboardCache();

let toastHandler = null;

export function registerClipboardToastCallback(callback) {
	toastHandler = callback;
}

function triggerToast() {
	if (typeof toastHandler === "function") {
		try {
			toastHandler();
		} catch (err) {
			console.warn("Clipboard toast callback failed", err);
		}
	}
}

export async function copyToClipboard(text) {
	const normalizedText = typeof text === "string" ? text : text != null ? String(text) : "";
	cachedClipboardText = normalizedText;

	if (navigator?.clipboard?.writeText) {
		try {
			await navigator.clipboard.writeText(normalizedText);
			triggerToast();
			return true;
		} catch (err) {
			console.warn("navigator.clipboard.writeText failed", err);
		}
	}

	try {
		const textarea = document.createElement("textarea");
		textarea.value = normalizedText;
		textarea.setAttribute("readonly", "");
		textarea.style.position = "fixed";
		textarea.style.opacity = "0";
		document.body.appendChild(textarea);
		textarea.focus();
		textarea.select();
		const succeeded = document.execCommand("copy");
		document.body.removeChild(textarea);
		if (succeeded) {
			triggerToast();
		}
		return succeeded;
	} catch (err) {
		console.warn("Fallback clipboard copy failed", err);
		return false;
	}
}

export const copy = copyToClipboard;

export async function readClipboardText() {
	if (navigator?.clipboard?.readText) {
		try {
			const text = await navigator.clipboard.readText();
			if (typeof text === "string") {
				cachedClipboardText = text;
				return text;
			}
		} catch (err) {
			console.warn("navigator.clipboard.readText failed", err);
		}
	}
	return cachedClipboardText;
}

export function getClipboard() {
	return cachedClipboardText;
}

export function isClipboardEmpty() {
	return !cachedClipboardText;
}
